export default "__VITE_ASSET__24898613__"